export const findPath = (obj, name, val, currentPath) => {
  currentPath = currentPath || '';

  let matchingPath;

  if (!obj || typeof obj !== 'object') return;

  if (obj[name] === val) return `${currentPath}['${name}']`;

  for (const key of Object.keys(obj)) {
    if (key === name && obj[key] === val) {
      matchingPath = currentPath;
    } else if (key !== 'parent') {
      matchingPath = findPath(obj[key], name, val, `${currentPath}['${key}']`);
    }

    if (matchingPath) break;
  }

  return matchingPath;
};

export const formatPath = (path) => {
  const pathArray = path.split('[');

  const pathArrayFormatted = pathArray.map((item) => {
    let itemFormatted = item.replace(/'/g, '').replace(']', '').trim();
    if (!isNaN(parseInt(itemFormatted))) {
      itemFormatted = parseInt(itemFormatted);
    } else if (!isNaN(+itemFormatted)) {
      itemFormatted = +itemFormatted;
    }
    return itemFormatted;
  });

  const pathArrayWithoutFirstElement = pathArrayFormatted.slice(1);
  let pathArrayWithoutLastElement = pathArrayWithoutFirstElement.slice(0, -1);

  const formattedArray = formatArray(pathArrayWithoutLastElement);

  formattedArray[formattedArray.length - 1] = formattedArray[
    formattedArray.length - 1
  ].replace('.', '');

  return formattedArray.join('');
};

export const loopTreeData = (data, callback) => {
  Object.keys(data).map((key) => {
    if (data[key].nodes) {
      loopTreeData(data[key].nodes, callback);
    }
    callback(data[key]);
  });
};

const formatArray = (arr) => {
  return arr.reduce((acc, curr) => {
    if (typeof curr === 'number') {
      acc.push(`[${curr}].`);
    } else {
      acc[acc.length - 1] += `${curr}`;
    }
    return acc;
  }, []);
};

export const validateNode = (nodeData) => {
  const actionType = nodeData?.action?.type;
  const actionMessage = nodeData?.action?.message;

  if (
    (actionType === 'SUBMENU' ||
      actionType === 'SUBMENU_BUTTONS' ||
      actionType === 'SEND_AWAIT' ||
      actionType === 'CONDITIONAL_CHECK' ||
      actionType === 'CREATE_PROTOCOL' ||
      actionType === 'EXECUTE_INTEGRATION') &&
    Object.keys(nodeData.nodes ?? {}).length == 0
  ) {
    return false;
  }

  if (
    (actionMessage === undefined || actionMessage === '') &&
    actionType !== 'CONDITIONAL_CHECK' &&
    actionType !== 'LINKMENU' &&
    actionType !== 'RETURN' &&
    actionType !== 'EXECUTE_INTEGRATION' &&
    actionType !== 'CREATE_PROTOCOL' &&
    actionType !== 'RP'
  ) {
    return false;
  }

  if (actionType === undefined || actionType === '') {
    return false;
  }

  if (nodeData?.chooseNodeQueue === true && nodeData?.nodeQueue === undefined) {
    return false;
  }

  if (actionType === 'LINKMENU' && nodeData?.action?.to === undefined) {
    return false;
  }

  if (
    actionType === 'ET' &&
    (nodeData?.action?.queue === undefined ||
      nodeData?.action?.queueName === undefined)
  ) {
    return false;
  }

  if (
    actionType === 'TTW' &&
    (nodeData?.action?.watsonConfig?.id === undefined ||
      nodeData?.action?.watsonConfig?.jumpInitial === undefined)
  ) {
    return false;
  }

  if (
    actionType === 'EXECUTE_INTEGRATION' &&
    nodeData.integrationFunctionName?.length === 0
  ) {
    return false;
  }

  if (
    actionType === 'CREATE_PROTOCOL' &&
    !nodeData.action?.protocol?.recordTypeId
  ) {
    return false;
  }

  return true;
};
